import { useState, useEffect } from "react";
import { getPartyList, getAllPartyList, getRegions } from "../../../../api/ph-api";
import { SeoTag, CxenseParseTag } from "../../../../../components/seo/SeoTag";
import RacesPage from "../../../../../components/races/RacesPage";

export const getStaticProps = async () => {
  let regionList = await getRegions();
  let partyList = await getPartyList();
  let allPartyList = await getAllPartyList();

  if (!regionList || !partyList || !allPartyList) {
    return {
      props: { partyList, allPartyList, regionList },
      revalidate: 5
    }
  }

  return {
    props: { partyList, allPartyList, regionList },
  };
};

const PartyListNational = ({ partyList, allPartyList, regionList }) => {
  const [url, setUrl] = useState("");
  const title = "Party list groups and nominees - 2022 Philippine elections";
  const description =
    "Each voter can vote for one party list group. Get to know the nominees by clicking the names to access their profiles. Bookmark this page to see partial, unofficial, real time election results based from the Comelec media server on May 9, 2022. The percentage of votes received is computed based on the total number of actual voters in each contest";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords="2022 Philippine elections, #PHVote, Philippine elections, , senatorial candidates philippines"
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <RacesPage
        path="party-list"
        partyList={partyList}
        allPartyList={allPartyList}
        regionList={regionList}
        url={url}
      />;
    </>
  );
};

export default PartyListNational;
